import { createContext, useContext } from 'react';

// Handlers that open an entity's detail view in-panel (PhoebeChatView's
// CaregiverDetailModal / ClientDetailModal). Provided by PhoebeChatView so that
// deeply-rendered entity references (markdown reference badges) can open the
// same in-panel detail that tool-call outputs already do — without navigating
// out of the panel. Empty by default (no handler → badge is non-interactive).
type EntityDetailClickHandlers = {
    readonly onCaregiverClick?: (caregiverId: string) => void;
    readonly onClientClick?: (clientId: string) => void;
};

const EntityDetailClickContext = createContext<EntityDetailClickHandlers>({});

export const EntityDetailClickProvider = EntityDetailClickContext.Provider;

export function useEntityDetailClick(): EntityDetailClickHandlers {
    return useContext(EntityDetailClickContext);
}
